import { render } from "./FloodProfileWidget.vue?vue&type=template&id=145e130f&ts=true"
import script from "./FloodProfileWidget.vue?vue&type=script&lang=ts"
export * from "./FloodProfileWidget.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__